<script setup lang="ts">
defineProps({
  item: {
    type: Object as PropType<CraftItem>,
    required: false,
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const route = useRoute();
const { trackEvent } = useGAnalytics();
const isModalCraftShown = ref<boolean>(false);

watch(
  () => route.query.craft,
  (value) => {
    if (value) isModalCraftShown.value = true;
  },
  { immediate: true }
);
</script>

<template>
  <div class="flex items-center gap-4 pl-7 pt-4 pb-5 flex-wrap">
    <div
      v-if="item && item.number == 0"
      class="bg-primary-900 rounded-sm p-1.5 flex items-start gap-2 mr-2">
      <NuxtIcon
        name="mdi:information"
        class="text-rarity-exotic h-4 w-4 flex-shrink-0 mt-1" />
      <ClientOnly>
        <p class="text-rarity-exotic text-left">
          {{ $t("main.cardCollectible.soldVisitMarketBegin") }}
          <NuxtLinkLocale
            :to="`/market/${item.merchantId}/stack/${item.setId}`"
            class="underline">
            {{ $t("main.cardCollectible.soldVisitMarketLink") }}
          </NuxtLinkLocale>
          {{ $t("main.cardCollectible.soldVisitMarketEnd") }}
        </p>
      </ClientOnly>
    </div>
    <BaseButtonSubmit
      v-else
      :disabled="disabled"
      data-test="button-craft"
      class="w-72"
      @click="
        (isModalCraftShown = true), trackEvent('craft_button', { id: item?.id })
      "
      :contextual-styles="true">
      <template #text>
        {{ $t("main.craftableDetail.craft") }}
      </template>
      <template #image-suffix>
        <NuxtIcon name="mdi:hammer-wrench" class="w-4 h-4 text-neutral-200" />
      </template>
    </BaseButtonSubmit>
    <ModalCraft
      v-if="isModalCraftShown"
      :craftable="item"
      @close="isModalCraftShown = false" />
  </div>
</template>
